export const RECEIVE_MAPPING_PLACE_SEND = 'RECEIVE_MAPPING_PLACE_SEND';
export const RECEIVE_PLACE_SEND = 'RECEIVE_PLACE_SEND';
export const EDIT_MAPPING_PLACE_SEND = 'EDIT_MAPPING_PLACE_SEND';
export const SAVE_MAPPING_PLACE_SEND = 'SAVE_MAPPING_PLACE_SEND';
